import { listenToAuthForms } from "./authForms";
import {
    CartClassName,
    CartId,
    CartDataAttribute,
    CartItemDataAttribute,
} from "./types";
import { listenToCheckoutButtonClick } from "./checkout";
import { fireDataLayerViewCartEvent } from "./analytics";
import {
    updatePreviousPurchaseState,
    listenToRemoveItemClick,
    bindCartCounters,
    bindGiftCheckboxes,
    listenToPreviouslyPurchasedChanges,
    initPopovers,
} from "./itemsAndTotals";

export function onLoad(): void {
    // Sync input values with server-provided quantities before bindCounters initializes
    $(`.${CartClassName.CartItemCard}`).each(function () {
        const $card = $(this);
        const $cartItem = $card.find(`.${CartClassName.CartItem}`);
        const serverQuantity = Number(
            $cartItem.data(CartItemDataAttribute.Quantity),
        );

        const $counter = $card.find(`[data-${CartDataAttribute.CartCounter}]`);
        if ($counter.length === 0) {
            return;
        }

        // Use server quantity if available, otherwise default to 1
        const quantity =
            serverQuantity && serverQuantity > 0 ? serverQuantity : 1;

        // Update both the input value and display before bindCounters initializes
        const $input = $counter.find(`.${CartClassName.ItemCountInput}`);
        const $display = $counter.find(`.${CartClassName.ItemCountDisplay}`);
        const $minusBtn = $counter.find(`.${CartClassName.Minus}`);

        if ($input.length > 0) {
            $input.val(quantity.toString());
        }
        if ($display.length > 0) {
            $display.text(quantity.toString());
        }
        if ($minusBtn.length > 0) {
            $minusBtn.prop("disabled", quantity === 1);
        }
    });

    updatePreviousPurchaseState();

    fireDataLayerViewCartEvent();
    listenToCheckoutButtonClick();
    listenToRemoveItemClick();
    $(`#${CartId.CartCalculatedTotalCopy}`).text(
        $(`#${CartId.CartCalculatedTotal}`).text(),
    );
    bindCartCounters();
    bindGiftCheckboxes();

    $(document).on("click", `.${CartClassName.BulkAlertClose}`, function () {
        $(`#${CartId.BulkPurchaseAlert}`).removeClass("is-visible");
    });

    listenToPreviouslyPurchasedChanges();
    initPopovers();

    // Auth Forms
    listenToAuthForms();
}

if (!SaNavigationUtils.NodeEnv.isTest()) {
    $(onLoad);
}
